import React, { useEffect, useRef } from "react";
import { Card } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useHolidayGuard } from "hooks/useHolidayGuard";
import { addPaymentAction } from "store/actions/orderActions";

const Paypal = ({
  totalAmount = 0,
  currency,
  restaurantsDetail,
  isHoliday,
  paypalClientKey,
  paypalFeesType = "fixed",
  paypalFees = 0,
  paypalAmount = 0,
  confirmOrder,
}) => {
  const dispatch = useDispatch();
  const paypal = useRef();
  const { user } = useSelector((state) => state.auth);

  const { holidayStatus, checkAndToast } = useHolidayGuard(
    restaurantsDetail,
    "dinein"
  );
  useEffect(() => {
    if (!paypalClientKey || checkAndToast()) return;
    const script = document.createElement("script");
    script.src = `https://www.paypal.com/sdk/js?client-id=${paypalClientKey}&currency=USD`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (paypal.current && window.paypal) {
        window.paypal
          .Buttons({
            createOrder: (data, actions) => {
              return actions.order.create({
                intent: "CAPTURE",
                purchase_units: [
                  {
                    reference_id: "default",
                    description: "Account Fee",
                    amount: {
                      currency_code: "USD",
                      value: paypalAmount.toString(),
                    },
                  },
                ],
              });
            },
            onApprove: async (data, actions) => {
              await actions.order.capture();

              const orderID = await confirmOrder("paypal", true);
              if (orderID) {
                const paymentObject = {
                  orderId: orderID,
                  paymentMethod: "paypal",
                  amount: (paypalAmount || 0).toString(),
                  status: "status",
                  uid: user?.id,
                };
                dispatch(addPaymentAction(paymentObject));
              }
            },
            onError: (err) => {
              toast.error(err.message || "Payment failed");
            },
          })
          .render(paypal.current);
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [paypalAmount, paypalClientKey]);

  return (
    <Card
      className="p-3 mb-3 cart__payment_card"
      style={{ border: "1px solid rgba(0, 0, 0, .125)" }}
    >
      <div ref={paypal}></div>
      <div className="d-flex justify-content-center my-2 text-dark">
        <span className="fs--20 fw--400 mr-2">Tax Fees:</span>
        <span className="fs--20 fw--400">
          &nbsp;
          {paypalFeesType === "percentage" ? "%" : currency}
          {paypalFees || 0}
        </span>
      </div>
      <div className="d-flex justify-content-center my-1 text-dark">
        <span className="fs--20 fw--400 mr-1">Total Amount:</span>
        <span className="fs--20 fw--400">
          {currency}&nbsp;{paypalAmount ? paypalAmount?.toFixed(2) : 0}
        </span>
      </div>
    </Card>
  );
};

export default Paypal;
